var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3744_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.326 137.059C138.043 140.49 134.936 142.703 132.485 144.45C103.643 165.002 69.5096 159.01 62.2539 157.548C51.54 155.386 30.8368 151.21 15.8669 133.73C-6.78329 107.278 -3.25163 65.605 14.3105 38.1C17.5252 33.0702 34.4986 5.13844 68.9946 0.660488C89.8789 -2.0479 114.216 3.42009 131.84 18.083C168.832 48.8653 166.2 111.05 141.326 137.059Z",
    fill: "#E1EBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7948 111.148L64.3594 142.141H104.243L99.0477 111.148H67.7948Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.798828 34.7742V105.761C0.798828 111.599 5.42847 116.379 11.2353 116.527C37.0266 117.198 127.231 118.814 151.783 118.45C156.005 118.387 159.424 114.99 159.542 110.751C160.018 94.2621 160.782 54.6035 157.941 36.191C157.341 32.3162 154.086 29.4143 150.187 29.2891C128.578 28.595 32.9516 26.3873 8.4168 26.9392C4.17768 27.0416 0.798828 30.5182 0.798828 34.7742Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22852 34.4267V101.869C5.22852 105.277 7.95084 108.06 11.341 108.105L148.249 109.806C151.611 109.858 154.368 107.138 154.379 103.758L154.605 36.9189C154.617 34.5007 152.698 32.5206 150.293 32.4637L10.1298 29.6188C7.44146 29.5505 5.22852 31.724 5.22852 34.4267Z",
    fill: "#A0CDDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M155.408 112.576C155.403 112.576 155.403 112.576 155.408 112.576L5.22219 110.004C5.11466 110.004 5.02976 109.913 5.03542 109.805C5.03542 109.697 5.13164 109.612 5.23351 109.617L155.414 112.189C155.521 112.189 155.606 112.28 155.601 112.388C155.595 112.491 155.51 112.576 155.408 112.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M81.7955 115.723C80.8277 115.723 80.041 114.932 80.041 113.959C80.041 112.986 80.8277 112.195 81.7955 112.195C82.7633 112.195 83.55 112.986 83.55 113.959C83.55 114.932 82.7633 115.723 81.7955 115.723ZM81.7955 112.582C81.0428 112.582 80.4259 113.202 80.4259 113.959C80.4259 114.716 81.0428 115.336 81.7955 115.336C82.5483 115.336 83.1652 114.716 83.1652 113.959C83.1652 113.202 82.5483 112.582 81.7955 112.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.833 148.481H54.4586C52.8739 148.481 51.6797 147.349 51.991 146.126L52.7381 143.15C52.9645 142.257 53.9436 141.597 55.1095 141.562L111.384 139.799C112.601 139.759 113.676 140.407 113.942 141.341L115.295 146.086C115.64 147.309 114.446 148.481 112.833 148.481Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8799 142.364C85.7724 142.364 85.6875 142.279 85.6875 142.171C85.6875 142.063 85.7724 141.977 85.8799 141.972L88.291 141.938C88.3985 141.938 88.4834 142.023 88.4834 142.131C88.4834 142.239 88.3985 142.324 88.291 142.33L85.8799 142.364C85.8856 142.364 85.8856 142.364 85.8799 142.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1503 146.839C54.139 146.839 54.1277 146.839 54.122 146.839C54.0145 146.822 53.9466 146.725 53.9635 146.617L54.3088 144.449C54.4955 143.283 55.4803 142.424 56.6519 142.407L82.2281 142.031C82.3357 142.031 82.4206 142.117 82.4206 142.225C82.4206 142.333 82.3357 142.418 82.2281 142.424L56.6519 142.799C55.6671 142.816 54.8351 143.533 54.6823 144.512L54.3371 146.68C54.3258 146.777 54.2409 146.839 54.1503 146.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4761 15.5692L42.2734 85.1681C41.3678 86.6987 42.5507 88.5649 44.4297 88.582L126.105 89.2591C127.995 89.2762 129.212 87.4099 128.324 85.8679L87.851 15.592C86.9228 13.9817 84.4269 13.9647 83.4761 15.5692Z",
    fill: "#31667F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6853 19.726L46.2633 82.9351C45.4427 84.3235 46.518 86.0191 48.2216 86.0361L122.398 86.6506C124.113 86.662 125.216 84.9721 124.413 83.5724L87.6584 19.7488C86.8151 18.2808 84.5456 18.2694 83.6853 19.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7112 153.078C34.7112 153.078 34.3037 155.411 34.0999 157.721C34.0207 158.626 34.7112 159.405 35.6167 159.445C38.6786 159.576 45.2213 159.821 47.5701 159.718C47.921 159.701 48.153 159.337 48.0228 159.007C47.9153 158.728 47.7002 158.506 47.4342 158.381L36.6242 153.385L34.7112 153.078Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 151.714L34.7033 154.507C34.7033 154.507 36.5993 155.395 37.8897 154.394L37.103 151.281L34.375 151.714Z",
    fill: "url(#paint0_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6282 99.2344C34.4867 99.9627 33.8641 135.61 37.6561 151.587C37.7184 151.849 37.5882 152.116 37.3392 152.219C36.7562 152.458 35.6186 152.805 34.2546 152.85C33.8302 152.867 33.451 152.589 33.3321 152.179C32.2511 148.475 27.0555 129.903 26.382 112.162C25.6236 92.3382 26.382 111.485 26.382 111.485L26.8234 99.2344H34.6282Z",
    fill: "url(#paint1_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.277 154.305C22.277 154.305 21.6261 155.483 20.9922 158.612C20.879 159.175 21.2695 159.716 21.8412 159.773C22.8543 159.875 24.405 160 25.6558 159.995C26.2274 159.989 26.6802 159.488 26.6067 158.914C26.4708 157.77 26.0407 155.898 24.7106 154.436L22.277 154.305Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7051 150.714L22.4748 154.936C22.4748 154.936 23.2332 155.505 24.7443 155.095L24.3765 150.555L21.7051 150.714Z",
    fill: "url(#paint2_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6216 100.328C16.52 119.139 20.2951 146.815 21.5685 152.231C21.6477 152.561 21.9137 152.817 22.2477 152.874C22.8136 152.971 23.7531 153.045 24.67 152.778C24.987 152.687 25.2133 152.396 25.2247 152.066C25.3945 147.685 25.0888 120.8 27.9753 110.172C28.1224 109.631 28.4507 109.164 28.9035 108.84L34.5122 104.834L34.9424 98.3594L19.6216 100.328Z",
    fill: "url(#paint3_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2189 73.5118C46.7491 76.8802 46.2511 77.6541 45.8662 77.6768C44.638 77.7394 44.8814 70.1434 40.3819 66.3027C37.5408 63.8731 33.6582 63.674 30.6133 63.9585C32.0339 69.0794 33.4545 74.206 34.875 79.3269C35.4976 80.8575 38.203 87.0481 44.3211 88.9257C45.5662 89.307 47.4226 89.876 49.1488 89.1306C52.556 87.6569 54.152 81.6313 52.6296 74.0808C51.9108 73.8191 50.9203 73.5346 47.2189 73.5118Z",
    fill: "url(#paint4_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1328 60.375L46.6988 63.5784C47.6043 67.4931 47.6892 70.7591 47.2195 73.513C47.9949 73.5471 48.8155 73.5983 49.6645 73.6837C50.7115 73.7861 51.702 73.9227 52.6302 74.082C52.1434 70.099 49.506 63.4874 49.506 63.4874C47.91 61.183 47.7232 62.6851 46.1328 60.375Z",
    fill: "url(#paint5_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5741 53.6258C51.9346 53.6087 51.3233 53.8818 50.9158 54.3768L46.8974 59.162C46.8974 59.162 46.1673 59.0141 46.0994 57.603C46.0315 56.1976 44.543 56.0269 44.543 56.0269C44.543 56.0269 44.758 57.9899 45.1655 60.8974C45.3976 62.5589 46.3767 63.7708 47.1691 64.5048L49.4952 63.7026C51.6289 60.6357 52.9533 57.2616 53.6891 53.6542L52.5741 53.6258Z",
    fill: "url(#paint6_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7012 66.6496C14.9672 66.5813 16.8009 64.6752 17.0726 64.624C21.5834 63.7591 32.8462 60.7093 40.3793 66.3025C40.3963 66.4618 40.4076 66.5927 40.4189 66.7008C40.4925 66.8032 40.5943 66.9682 40.7302 67.2357C41.4433 68.624 42.2979 69.9725 43.2714 71.23C43.0563 71.4462 42.8752 71.6965 42.745 71.9753C40.9339 75.8729 34.0687 91.4519 35.2742 100.971C35.3365 101.46 35.0026 101.916 34.5158 101.984C31.8501 102.354 23.9152 103.258 19.8176 101.557C19.5798 101.46 19.427 101.221 19.4327 100.965C19.461 99.0536 19.3818 90.7634 16.3538 80.7662C16.2406 80.3964 16.1501 80.0152 16.0765 79.6339C16.0369 79.7136 16.0029 79.7876 15.9689 79.8615L14.7012 66.6496Z",
    fill: "url(#paint7_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5865 63.7578C13.1762 64.378 11.416 69.2087 5.60352 66.2557L6.63358 75.3083C8.78993 77.7038 12.0443 79.3311 16.1476 79.9456L21.5865 63.7578Z",
    fill: "url(#paint8_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3297 55.5781C25.8865 58.4686 25.2866 61.4103 25.1055 64.1471C25.4168 64.2609 29.554 67.1514 32.3216 64.3576C31.7273 62.4401 31.8292 59.5554 31.9764 56.5966L27.3297 55.5781Z",
    fill: "url(#paint9_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8331 47.9795C34.9123 48.1104 36.9781 57.9141 36.9781 57.9141L31.3863 58.9838L28.0527 49.9881C28.0584 49.9824 33.5087 45.8231 34.8331 47.9795Z",
    fill: "url(#paint10_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1921 50.7816C30.045 50.9864 29.9941 51.2482 30.0676 51.4928L31.4316 56.2951C31.4543 56.3691 31.4826 56.4374 31.5222 56.4999C31.7429 56.8527 32.5353 57.9281 33.6049 57.0462C34.5162 56.2951 35.3651 55.618 36.1235 55.453C36.565 55.3563 37.0008 55.6465 37.097 56.0903C37.2894 57.012 37.6347 58.8783 37.7139 60.5739C37.7309 61.0007 37.4196 61.3648 36.9951 61.4217C35.8858 61.5583 33.7068 61.7631 31.8787 61.5355C31.5788 61.4957 31.3241 61.2965 31.2165 61.0177C30.7355 59.7716 29.3828 56.2837 28.8508 55.362C28.3527 54.5028 27.0397 54.4231 26.4341 54.4345C26.202 54.4402 25.987 54.3492 25.8228 54.1785C25.3418 53.6778 24.5777 52.5512 25.8794 51.3392C26.202 51.0376 26.2134 50.5256 25.9247 50.1955C25.3984 49.6038 24.9173 48.6251 25.9191 47.5213C26.9321 46.4061 28.1546 46.6109 28.9357 46.9295C29.2809 47.0718 29.6997 46.9807 29.9261 46.6792C30.028 46.5483 30.1808 46.4516 30.4185 46.4687C30.8656 46.4971 31.2505 46.1785 31.2788 45.729C31.3297 44.9551 31.692 44.0334 33.0277 43.7034C35.4783 43.1002 36.8366 45.5298 36.8819 47.2823C36.9272 49.0348 34.2275 49.5412 32.6768 49.325C31.5335 49.1657 30.6053 50.2126 30.1921 50.7816Z",
    fill: "#14262F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6813 57.1897C29.6813 57.1897 29.1607 54.0887 27.9155 53.8611C26.6704 53.6335 25.3913 54.5951 26.5346 56.3704C27.9551 58.5781 29.6813 57.1897 29.6813 57.1897Z",
    fill: "url(#paint11_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6313 46.0263C27.8463 46.0149 28.0841 46.0377 28.3444 46.0946C28.933 46.2197 29.7254 46.527 29.516 47.096C29.2103 47.9552 27.6086 47.1529 26.7597 48.5355C26.0126 49.7532 26.6239 51.0789 26.3918 52.3933C26.2786 53.0305 25.8711 53.9808 25.3051 54.3563C25.0505 54.5213 23.0469 54.8456 22.9337 54.4872L22.3734 52.6664C21.8697 51.0277 23.7997 48.3022 24.7958 47.1984C25.5655 46.3506 26.6069 46.0718 27.6313 46.0263Z",
    fill: "url(#paint12_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7298 52.6019L23.8111 54.2064C20.1323 55.7825 17.4553 57.6317 15.5197 59.6403C14.8178 58.3145 13.6802 56.7782 11.8691 55.5834C15.5763 53.7455 18.3382 52.9831 18.3382 52.9831C25.826 49.956 25.7298 52.6019 25.7298 52.6019Z",
    fill: "url(#paint13_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5192 59.635C9.46892 65.8996 11.2348 62.7133 11.1895 68.0561C11.1725 70.0475 9.45194 77.6492 9.45194 77.6492C-9.05531 69.6151 6.39004 58.645 11.8686 55.5781C13.6797 56.773 14.8173 58.3093 15.5192 59.635Z",
    fill: "url(#paint14_linear_3744_1315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7034 66.2831L83.3246 66.2034C82.3851 66.1807 81.604 65.3727 81.5531 64.4168L80.3193 40.4965C80.291 40.0015 80.4721 39.5975 80.806 39.2618C81.1399 38.9261 81.6097 38.8236 82.0964 38.8578L87.9146 39.2675C88.39 39.3016 88.8485 39.4609 89.1711 39.8364C89.4993 40.212 89.6691 40.6615 89.6465 41.1394L88.441 64.6216C88.3957 65.5605 87.6316 66.3059 86.7034 66.2831Z",
    fill: "#31667F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4904 72.1241C82.3337 71.3161 83.5223 70.9235 85.0447 70.9462C86.6181 70.969 87.8067 71.3901 88.6273 72.1923C89.4423 72.9946 89.8498 74.1724 89.8498 75.7201C89.8498 77.2108 89.4367 78.3659 88.6047 79.1852C87.7727 80.0046 86.5898 80.4199 85.0504 80.4199C83.5449 80.4199 82.362 79.9932 81.5074 79.1454C80.6528 78.2919 80.2227 77.1255 80.2227 75.6461C80.2227 74.1155 80.6471 72.9377 81.4904 72.1241Z",
    fill: "#31667F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3744_1315",
    x1: 34.3755,
    y1: 153.077,
    x2: 37.8925,
    y2: 153.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3744_1315",
    x1: 37.8752,
    y1: 150.157,
    x2: 31.8546,
    y2: 89.2005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14262F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3744_1315",
    x1: 21.7026,
    y1: 152.898,
    x2: 24.7392,
    y2: 152.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3744_1315",
    x1: 23.1918,
    y1: 151.441,
    x2: 23.6218,
    y2: 96.8955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14262F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3744_1315",
    x1: 74.678,
    y1: 72.2952,
    x2: 42.5494,
    y2: 71.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#A0CDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3744_1315",
    x1: 34.2798,
    y1: 47.3016,
    x2: 70.1104,
    y2: 100.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3744_1315",
    x1: 39.9484,
    y1: 43.4957,
    x2: 75.7789,
    y2: 96.8733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3744_1315",
    x1: 32.976,
    y1: 72.7215,
    x2: 13.6501,
    y2: 121.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0CDDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3744_1315",
    x1: 24.2507,
    y1: 73.3634,
    x2: -11.9238,
    y2: 69.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31667F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3744_1315",
    x1: 32.6446,
    y1: 54.6491,
    x2: 18.3784,
    y2: 81.2869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3744_1315",
    x1: 13.4515,
    y1: 50.8654,
    x2: 40.8221,
    y2: 54.1306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3744_1315",
    x1: 13.0853,
    y1: 53.9249,
    x2: 40.4561,
    y2: 57.1901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3744_1315",
    x1: 29.1632,
    y1: 47.9217,
    x2: 7.00952,
    y2: 62.8613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3744_1315",
    x1: 28.7218,
    y1: 47.4782,
    x2: 5.67581,
    y2: 63.0196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3744_1315",
    x1: 14.031,
    y1: 71.6577,
    x2: 0.293255,
    y2: 41.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31667F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0CDDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3744_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorModal);
export default __webpack_public_path__ + "static/media/error-modal.4e76913e6d369028b3f17dc99efd8399.svg";
export { ForwardRef as ReactComponent };